var _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStepSelectGoalComplete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    fill: "url(#paint0_linear_396_239)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_396_239",
    x1: -2.18682,
    y1: 5.04053,
    x2: 9.43768,
    y2: 5.55472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2468FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1DCAFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepSelectGoalComplete);
export default __webpack_public_path__ + "static/media/step_select_goal_complete.fece3c69ab56173cd8b5bdc4d0f6a91d.svg";
export { ForwardRef as ReactComponent };